import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { Observable, Subject, firstValueFrom, lastValueFrom, takeUntil, tap } from 'rxjs';

import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-chat-message',
  templateUrl: './chat-message.component.html',
  styleUrls: ['./chat-message.component.css']
})
export class ChatMessageComponent implements OnInit, OnChanges {

  @Input() participantId: number;
  @Input() messageData: any;
  @Input() studentId: number;
  @Input() studentAvatar: any;
  @Input() youthWorkerAvatar: any;
  avatarId: any;

  messageDate = new Date(0);
  assetData: any;

  private destroyed$ = new Subject();

  constructor(private _chatService: ChatService) { }

  ngOnInit() {
    if (this.messageData.hasAsset) {
      this.getAsset(this.messageData.assetDownloadId).subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        this.assetData = url;
      });
    }
    this.getAvatarById().subscribe((data) => {
      // console.log("Participant avatar ID: ", data)
      this.avatarId = data;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['messageData'] && this.messageData) {
      this.messageDate.setUTCSeconds(this.messageData.modified)
    }
  }

  getAsset(id: number): Observable<any> {
    return this._chatService.getAsset(id);
  }

  getAvatarById(): Observable<any> {
    return this._chatService.getAvatarBase64(this.participantId).pipe(
      takeUntil(this.destroyed$)
    )
  }

  onPdfDownloadClick(assetLink: any) {
			window.open(assetLink, '_blank');
	}

  imageTypeMap: { [key: string]: string } = {
		'image/png': 'png',
		'image/x-png': 'png',
		'image/jpeg': 'jpeg',
		'image/gif': 'gif',
		'image/jpg': 'jpg',
		'image/heif': 'heif',
		'image/heic': 'heic',
	};

  downloadableContentTypeMap: { [key: string]: string } = {
		'application/msword': 'doc',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
	};

  pdfContentTypeMap: { [key: string]: string } = {
		'application/pdf': 'pdf'
	};

  isImageContent(contentType: string): boolean {
    return this.imageTypeMap.hasOwnProperty(contentType);
  }
  isDownloadableContent(contentType: string): boolean {
    return this.downloadableContentTypeMap.hasOwnProperty(contentType);
  }
  isPdfContent(contentType: string): boolean {
    return this.pdfContentTypeMap.hasOwnProperty(contentType);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  
}

